import moment from 'moment-timezone';


export function formatPrice(number) {
    if (!number && number !== 0) return '0';
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(number);
}

export function formatCurrency(number, currency = process.env.REACT_APP_CURRENCY || 'AED') {
    if (!number && number !== 0) return `${currency} 0`;
    return `${currency} ${formatPrice(number)}`;
}

export function formatDate(date, format = 'MMMM D, YYYY') {
    const timezone = process.env.REACT_APP_TIMEZONE || moment.tz.guess();
    return moment.tz(date, timezone).format(format);
}

export function formatTimeAgo(date) {
    const timezone = process.env.REACT_APP_TIMEZONE || moment.tz.guess();
    return moment.tz(date, timezone).fromNow();
}

